import Immutable from "immutable";
import keyConverter from "services/key-converter";
import { convertSchedule } from "services/scheduleFormatConverter";

export const scheduleRuleRow = Immutable.Map({
  date: null,
  days: Immutable.List(),
  start: "08:00",
  end: "17:00",
  allDay: false,
  invalidFields: Immutable.List(), // list of {field, errorMessage}
  conflictingDays: Immutable.Map({
    days: Immutable.Set(),
    errorMessage: ""
  })
});

export const ScheduleRecord = Immutable.Record({
  id: null,
  name: "",
  timezone: "",
  normalOperatingDays: Immutable.List(),
  normalOperatingDaysRows: Immutable.List([scheduleRuleRow]),
  specialOperatingDays: Immutable.List(),
  specialOperatingDaysRows: Immutable.List(),
  isValid: false,
  hasErrors: false
});

const settingsScheduledBlockSchedulesList = Immutable.List();

export const settingsScheduledBlockSchedules = (
  state = settingsScheduledBlockSchedulesList, action
) => {
  let nextState = state;

  switch (action.type) {
    case "FETCH_ONE_CLIENT_SUCCESS": {
      const schedules = Immutable.fromJS(
        keyConverter(action.response.data.client.scheduled_block_schedules)
      );

      if (schedules) {
        nextState = Immutable.List(
          schedules.map(schedule => new ScheduleRecord(convertSchedule(schedule)))
        );
      }

      return nextState;
    }

    case "PATCH_SCHEDULED_BLOCK_SCHEDULES_SUCCESS": {
      const schedules = Immutable.fromJS(
        keyConverter(action.response.data.scheduled_block_schedules)
      );

      if (schedules) {
        nextState = Immutable.List(
          schedules.map(schedule => new ScheduleRecord(convertSchedule(schedule)))
        );
      }

      return nextState;
    }

    default:
      return nextState;
  }
};
